import React from 'react';
import { useWebroot } from '../../hooks';

interface LogoProps {
  className?: string;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', height = 40 }) => {
  const { webroot } = useWebroot();
  
  return (
    <img 
      src={`${webroot}/samler.png`}
      alt="Samler"
      height={height}
      className={className}
      style={{ height: `${height}px`, width: 'auto' }}
    />
  );
};

export default Logo;